export default __webpack_public_path__ + "static/pco_circles_half_with_dot-4cc27bb3951e21c8d51f53ef07037096.png";